import { Typography } from "@mui/material"

interface IProps {
  title: string,
  subtitle: string
}

const Heading: React.FC<IProps> = ({ title, subtitle }) => {
  return (
    <>
      <Typography variant="h5" component="h2" mb={2}>
        {title}
      </Typography>
      <Typography variant="body1" color="textSecondary" mb={{ xs: 4, md: 6 }}>
        {subtitle}
      </Typography>
    </>
  )
}

export default Heading
